/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import React, {useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, logout } from "../../features/user";
import { useTranslation } from 'react-i18next';
import {checkValidToken} from "../../Helper"

import Frame from '../widgets/Frame';
import { tBrand } from "../../portalSettings";

export function Congratulations() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const reseller = useSelector((state) => state.reseller.value);

    useEffect(()=>{
        if(isUserLoggedIn) {
            checkValidToken(navigate, dispatch, logout, true, true, "/register", "/congratulations");
        } else {
            navigate("/register");
        }
        // eslint-disable-next-line
    },[]);


    return (
            <Frame>
                <div className='main main-congratulations'>
                    <div className='main-top'>
                        <h1>{t("Congratulations")} {/* firstname */} {t("Your account has been successfully created.")}</h1>
                    </div>
                    <div className='main-body'>
                        <div className='right-main'>
                            <div className='right-main-inner'>
                                <h2>{tBrand(t, "Now you can start using Yemot Hamashiach services", reseller)}</h2>
                            </div>
                        </div>    
                        <div className='left-main'>
                            <img src='/images/person-paper-plane.png' className='content-logo' alt=''/>
                        </div>
                    </div>
                </div>
            </Frame>
    );
}